<template>
  <v-dialog v-model="visible"
    v-if="receipt"
    persistent
    scrollable
    width="700"
    content-class="glass-dialog">
    <v-form ref="sendEmail"
      @submit.prevent="submit"
      style="overflow-x: hidden">
      <v-card class="glass-card">
        <!-- Gradient Header -->
        <div class="glass-header">
          <v-row class="align-center ma-0">
            <v-col class="pa-0">
              <h2 class="dialog-title">{{ title }}</h2>
            </v-col>
            <v-col cols="auto" class="pa-0">
              <v-btn icon @click="close" class="close-btn">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <v-card-text class="dialog-content">
          <v-row class="mt-0">
            <v-col>
              <v-expansion-panels flat>
                <v-expansion-panel class="email-expansion-panel">
                  <v-expansion-panel-header
                    class="email-expansion-header"
                    expand-icon="mdi-plus"
                    @keyup.space.prevent="">
                    <v-combobox label="Primatelji"
                      v-model="emails"
                      multiple
                      :delimiters="[',', ' ']"
                      :items="[]"
                      append-icon=""
                      :rules="[rules.arrReq]"
                      @change="checkEmailAdresses"
                      @click.native.stop=""
                      :loading="loading"
                      deletable-chips
                      small-chips
                      dense
                      outlined
                      hide-details
                      class="filter-select">
                    </v-combobox>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="email-expansion-content">
                    <v-row class="mt-4">
                      <v-col>
                        <v-combobox label="Odgovori na"
                          v-model="replyTo"
                          :items="[]"
                          append-icon=""
                          @change="checkEmailAdresses"
                          :loading="loading"
                          deletable-chips
                          small-chips
                          dense
                          outlined
                          hide-details
                          class="filter-select">
                        </v-combobox>
                      </v-col>
                    </v-row>
                    <v-row class="mt-3">
                      <v-col>
                        <v-combobox label="Cc"
                          v-model="cc"
                          multiple
                          :delimiters="[',', ' ']"
                          :items="[]"
                          append-icon=""
                          @change="checkEmailAdresses"
                          :loading="loading"
                          deletable-chips
                          small-chips
                          dense
                          outlined
                          hide-details
                          class="filter-select">
                        </v-combobox>
                      </v-col>
                    </v-row>
                    <v-row class="mt-3">
                      <v-col>
                        <v-combobox label="Bcc"
                          v-model="bcc"
                          multiple
                          :delimiters="[',', ' ']"
                          :items="[]"
                          append-icon=""
                          @change="checkEmailAdresses"
                          :loading="loading"
                          deletable-chips
                          small-chips
                          dense
                          outlined
                          hide-details
                          class="filter-select">
                        </v-combobox>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>

          <v-row class="mt-3">
            <v-col>
              <v-text-field label="Naslov"
                v-model="emailTitle"
                dense
                outlined
                hide-details
                class="filter-select">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col>
              <v-textarea label="Poruka"
                v-model="emailText"
                ref="textarea"
                auto-grow
                row-height="20"
                rows="7"
                dense
                outlined
                hide-details
                class="filter-select"
                style="white-space: pre-line">
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-btn
            class="cancel-btn"
            @click="close"
            outlined
            text>
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn
            class="soft-button"
            :loading="submitting"
            :disabled="submitting"
            @click="submit">
            <v-icon small class="mr-2">mdi-send</v-icon>
            {{ okBtn }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <v-overlay v-if="loading"
      absolute
      z-index="10">
      <v-progress-circular indeterminate
        size="64"
        color="primary"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>
<script>
// import { v4 as uuidv4 } from 'uuid'
import { df, functions } from '@/plugins/firebase'
import state from '@/state'
import { clone } from '@/plugins/utils'
import rules from '@/plugins/rules'
import { callAssociates } from '@/api/associates'

export default {
  inject: ['showMsgBox'],
  name: 'SendEmail',
  data: function () {
    return {
      visible: false,
      loading: false,
      submitting: false,
      action: undefined,
      receipt: undefined,
      title: undefined,
      okBtn: undefined,
      emailText: '',
      emailTitle: '',
      emails: [],
      cc: [],
      bcc: [],
      rules: {
        arrReq: rules.arrReq(),
        email: rules.email()
      },
      associates: [],
      replyTo: '',
      documentType: 'racun',
      documentName: 'Račun'
    }
  },
  methods: {
    async open (receipt, params) {
      if (!params?.action) {
        this.showMsgBox({
          text: 'Nepoznata akcija',
          actions: ['cancel'],
          cancelBtnText: this.$t('$vuetify.close'),
          color: 'error'
        })
        return
      }
      if (!params?.title) {
        this.showMsgBox({
          text: 'Title nije poslan',
          actions: ['cancel'],
          cancelBtnText: this.$t('$vuetify.close'),
          color: 'error'
        })
        return
      }
      if (!params?.okBtn) {
        this.showMsgBox({
          text: 'okBtn nije poslan',
          actions: ['cancel'],
          cancelBtnText: this.$t('$vuetify.close'),
          color: 'error'
        })
        return
      }
      this.getReplyTo()
      this.action = params.action
      this.title = params.title
      this.okBtn = params.okBtn
      this.receipt = clone(receipt)
      switch (this.action) {
        case 'EMAIL_SENT':
          this.documentType = 'racun'
          this.documentName = `Račun ${receipt.receiptNumberForEmail}`
          this.emailTitle = `Račun ${receipt.receiptNumberForEmail}`
          this.emailText = `Poštovani/poštovana,

u privitku Vam šaljemo račun ${receipt.receiptNumberForEmail
            } za isporučene usluge u iznosu od ${this.$options.filters.money(
              receipt.total | 0,
              100,
              receipt.currency
            )}.

Srdačan pozdrav,
${state.getCurrentCompany().name}`
          break
        case 'WARNING_SENT':
          this.emailTitle = `Opomena po racunu ${receipt.receiptNumberForEmail}`
          this.emailText = `Poštovani/poštovana,

Vaša uplata za isporučene usluge po računu ${receipt.receiptNumberForEmail
            } (u iznosu od ${this.$options.filters.money(
              receipt.total | 0,
              100,
              receipt.currency
            )}) još nije evidentirana.

U privitak ove poruke je stavljena kopija računa te Vas molimo da isti podmirite u najkraćem roku.

Ukoliko ste u međuvremenu izvršili uplatu zanemarite ovu poruku.

Srdačan pozdrav,
${state.getCurrentCompany().name}`
          break
        case 'OFFER_SENT':
          this.documentType = 'ponuda'
          this.documentName = `Ponuda ${receipt.receiptNumberForEmail}`
          this.emailTitle = `Ponuda ${receipt.receiptNumberForEmail}`
          this.emailText = `Poštovani/poštovana,

u privitku Vam šaljemo ponudu ${receipt.receiptNumberForEmail
            } u iznosu od ${this.$options.filters.money(
              receipt.total | 0,
              100,
              receipt.currency
            )}.

Srdačan pozdrav,
${state.getCurrentCompany().name}`
          this.action = 'EMAIL_SENT'
          break
        case 'WORKORDER_SENT':
          this.documentType = 'radninalog'
          this.documentName = `Radni nalog ${receipt.workorderNumber}`
          this.emailTitle = `Radni nalog ${receipt.workorderNumber}`
          this.emailText = `Poštovani/poštovana,

u privitku Vam šaljemo radni nalog ${receipt.workorderNumber
            } za usluge u iznosu od ${this.$options.filters.money(
              receipt.total | 0,
              100,
              receipt.currency
            )}.

Srdačan pozdrav,
${state.getCurrentCompany().name}`
          this.action = 'EMAIL_SENT'

          break
      }
      this.visible = true

      // First check if receipt has eracun_email
      if (this.receipt?.eracun_email) {
        this.emails.push(this.receipt.eracun_email)
      }

      // If no OIB, can't search for associate
      if (!this.receipt?.type?.payer_oib) return

      this.loading = true
      await this.getAssociateByOib()
      this.loading = false
    },

    async getAssociateByOib () {
      const oib = this.receipt?.type?.payer_oib
      if (!oib) return

      const path = `/associates/${state.getCurrentCompany().id}/associate?filter=trigram(eq:${encodeURIComponent(oib)})`
      const response = await callAssociates('get', path)

      if (response && response.status === 200 && response.data && response.data.associates) {
        const associatesList = Object.keys(response.data.associates)
          .map((key) => response.data.associates[key])
          .filter((associate) => associate.status === 'OK')

        // Find associate with matching OIB
        const associate = associatesList.find(assoc =>
          assoc.oibs && assoc.oibs.includes(oib)
        )

        // Add email if it exists
        if (associate && associate.email && associate.email !== '') {
          this.emails.push(associate.email.replace(',', '').trim())
        }
      } else if (response.status === 404) {
        // Associate not found - continue silently
      } else {
        this.showMsgBox({
          text: 'Neuspjelo dohvaćanje podataka o klijentu',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },

    close () {
      this.emails = []
      this.visible = false
    },
    checkEmailAdresses () {
      this.emails = this.emails.filter((email) => rules.isEmail()(email))
    },
    async getReplyTo () {
      const query = df.collection(`company_communications/${state.getCurrentCompany().id}/communications`)
      await query.get()
        .then((documentSnapshots) => {
          if (documentSnapshots.docs && !documentSnapshots.docs.empty) {
            documentSnapshots.docs.forEach((item) => {
              var comm = item.data()

              if (comm.usage && comm.usage.length > 0) {
                comm.usage.forEach(usage => {
                  if (usage === 'reply_to') {
                    this.replyTo = comm.value
                  }
                })
              }
            })
          }
        })
    },
    submit () {
      this.emails = this.emails.filter((email) => rules.isEmail()(email))
      if (this.emails.length === 0) {
        return
      }
      this.loading = true
      var sendDocument = functions.httpsCallable('senddocument')

      var printTemplate = ''
      if (state.getCurrentCompany().print_template && state.getCurrentCompany().print_template !== '') {
        printTemplate = state.getCurrentCompany().print_template
      }

      sendDocument({
        to: this.emails,
        cc: this.cc,
        bcc: this.bcc,
        subject: state.getCurrentCompany().name + ' - ' + this.emailTitle,
        reply_to: this.replyTo,
        body: this.emailText.replace(/\n|\r\n|\r/g, '<br/>'),
        company_id: state.getCurrentCompany().id,
        document_id: this.receipt.id,
        template: printTemplate,
        document_type: this.documentType,
        document_name: this.documentName,
        document_action: this.action,
        hub3: true
      }).then((result) => {
        this.loading = false

        if (result.data.code === 200) {
          // Update receipt status based on action
          if (this.action === 'EMAIL_SENT') {
            if (!this.receipt.payment) this.receipt.payment = {}
            this.receipt.payment.current_status = 'EMAIL_SENT'
          } else if (this.action === 'WARNING_SENT') {
            if (!this.receipt.payment) this.receipt.payment = {}
            this.receipt.payment.current_status = 'WARNING_SENT'
          }

          // Emit event to update GUI
          this.$emit('receiptEdit', this.receipt)

          let subject = 'Email'
          if (this.action === 'WARNING_SENT') subject = 'Opomena'
          this.showMsgBox({
            text: `${subject} je poslan${subject === 'Opomena' ? 'a' : ''}.`,
            actions: ['cancel'],
            cancelBtnText: this.$t('$vuetify.close'),
            color: 'info'
          })
          this.close()
        } else {
          this.showMsgBox({
            text: 'Slanje maila nije uspjelo.',
            actions: ['cancel'],
            cancelBtnText: this.$t('$vuetify.close'),
            color: 'error'
          })
          this.close()
        }
      })
    }
    // submit () {
    //   if (!this.$refs.sendEmail.validate()) return

    //   let entity = 'receipt'
    //   if (this.receipt.type.flag === 'P') {
    //     entity = 'offer'
    //   }
    //   const payload = {
    //     action: {
    //       operation: 'get',
    //       entity: entity,
    //       resource_id: this.receipt.id,
    //       params: {
    //         action: this.action,
    //         emails: this.emails,
    //         subject: state.getCurrentCompany().name + ' - ' + this.emailTitle,
    //         template: 'receipt_email',
    //         body: this.emailText.replace(/\n|\r\n|\r/g, '<br/>'),
    //         company_id: state.getCurrentCompany().id,
    //         print_size: 'A4'
    //       }
    //     }
    //   }

    //   const reqId = uuidv4()
    //   this.submitting = true
    //   df.doc(`request/${reqId}`)
    //     .set({
    //       user_id: `${auth.currentUser.uid}`,
    //       device_id: 'web',
    //       created: `${new Date().getTime()}`,
    //       type: 'document',
    //       payload: btoa(unescape(encodeURIComponent(JSON.stringify(payload))))
    //     })
    //     .then(() => {
    //       this.$emit('receiptEdit', this.receipt)
    //       let subject = 'Email'
    //       if (this.action === 'WARNING_SENT') subject = 'Opomena'
    //       this.showMsgBox({
    //         text: `${subject} je poslan${subject === 'Opomena' ? 'a' : ''}.`,
    //         actions: ['cancel'],
    //         cancelBtnText: this.$t('$vuetify.close'),
    //         color: 'info'
    //       })
    //       this.close()
    //     })
    //     .catch((err) => {
    //       this.showMsgBox({
    //         text: err && err !== '' ? err : 'An error has occurred',
    //         actions: ['cancel'],
    //         cancelBtnText: this.$t('$vuetify.close'),
    //         color: 'error'
    //       })
    //     })
    //     .finally(() => {
    //       this.submitting = false
    //     })
    // }
  }
}
</script>
<style scoped>
/* Glass Dialog */
.glass-dialog {
  backdrop-filter: blur(20px) !important;
}

/* Glass Card */
.glass-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.1) !important;
  overflow: hidden;
}

/* Glass Header with Gradient */
.glass-header {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%) !important;
  padding: 24px 24px 20px;
  position: relative;
}

.dialog-title {
  font-size: 22px !important;
  font-weight: 600 !important;
  color: white !important;
  letter-spacing: 0.5px !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.close-btn {
  color: white !important;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
}

/* Dialog Content */
.dialog-content {
  padding: 24px !important;
}

/* Dialog Actions */
.dialog-actions {
  padding: 16px 24px 24px !important;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* Soft Button (Primary Action) */
.soft-button {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #3989C9 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(57, 137, 201, 0.15) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.soft-button:hover {
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  border-color: rgba(57, 137, 201, 0.3) !important;
  transform: translateY(-1px);
}

.soft-button .v-icon {
  font-size: 18px !important;
  color: #3989C9 !important;
}

/* Cancel Button */
.cancel-btn {
  background: transparent !important;
  color: rgba(57, 137, 201, 0.8) !important;
  border: 1px solid rgba(57, 137, 201, 0.3) !important;
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.cancel-btn:hover {
  background: rgba(57, 137, 201, 0.08) !important;
  border-color: rgba(57, 137, 201, 0.5) !important;
}

/* Filter Select Inputs */
.filter-select.v-text-field--outlined >>> fieldset {
  border-color: rgba(57, 137, 201, 0.2) !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: rgba(57, 137, 201, 0.4) !important;
}

.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

.filter-select >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  min-height: 36px !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined >>> .v-input__control {
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined >>> .v-text-field__slot {
  border-radius: 8px !important;
}

.filter-select >>> .v-select__selection,
.filter-select >>> .v-text-field__slot input,
.filter-select >>> .v-text-field__slot textarea {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  letter-spacing: 0.3px !important;
}

.filter-select >>> label {
  font-size: 12px !important;
  font-weight: 500 !important;
  color: rgba(57, 137, 201, 0.8) !important;
}

/* Filter Select Dropdown Menu */
.filter-select >>> .v-menu__content {
  background: rgba(255, 255, 255, 0.98) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 8px !important;
  border: 1px solid rgba(0, 179, 190, 0.15) !important;
  box-shadow: 0 8px 24px rgba(0, 179, 190, 0.12) !important;
}

.filter-select >>> .v-list-item {
  font-size: 13px !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
}

.filter-select >>> .v-list-item:hover {
  background: rgba(57, 137, 201, 0.08) !important;
}

.filter-select >>> .v-list-item--active {
  background: rgba(0, 179, 190, 0.12) !important;
  color: #3989C9 !important;
}

.filter-select >>> .v-simple-checkbox {
  color: #3989C9 !important;
}

/* Expansion Panel Tweaks */
.v-expansion-panels {
  background: transparent !important;
  margin: 0 !important;
}

.email-expansion-panel {
  background: transparent !important;
  box-shadow: none !important;
  margin: 0 !important;
}

.email-expansion-panel::before {
  box-shadow: none !important;
}

.email-expansion-header {
  padding: 0 !important;
  padding-right: 48px !important;
  min-height: 36px !important;
  max-height: 36px !important;
  display: flex !important;
  align-items: center !important;
}

/* Center the expansion icon with the input field */
.email-expansion-header >>> .v-expansion-panel-header__icon {
  margin: 0 !important;
  position: absolute !important;
  right: 12px !important;
  top: 14px !important;
  transform: translateY(-50%) !important;
}

/* Add proper spacing to expansion content */
.email-expansion-content {
  background: transparent !important;
}

.email-expansion-content >>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

/* Chips in combobox */
.filter-select >>> .v-chip {
  background: rgba(0, 179, 190, 0.15) !important;
  color: #3989C9 !important;
  border: 1px solid rgba(0, 179, 190, 0.3) !important;
}

.filter-select >>> .v-chip .v-icon {
  color: #3989C9 !important;
}
</style>
